module.exports = __webpack_public_path__ + "static/media/two_marker.82e58e84.svg";